import {
	AfterViewInit,
	Component,
	Input,
	OnInit
}                                       from '@angular/core';
import {
	FormControlBase,
	FormControlBaseComponent
}                                       from '@app/core/bases/form-control-base/form-control-base.component';
import { FORM_ELEMENTS_DEFAULT_CONFIG } from '@shared/form-elements/form-elements.config';

@Component( {
	selector: 'app-form-textarea[formEntityId][formGroup][config]',
	templateUrl: './form-textarea.component.html',
	styleUrls: [ './form-textarea.component.scss' ]
} )
export class FormTextareaComponent extends FormControlBaseComponent implements FormControlBase, AfterViewInit, OnInit {

	private readonly textAreaDefaultConfig = FORM_ELEMENTS_DEFAULT_CONFIG?.textArea;

	revertValue: string;

	currentTextLength: number;

	@Input() maxLength = this.textAreaDefaultConfig?.maxLength;

	constructor() {
		super();
	}

	private clearOnEmptyString( text: string ): void {
		if ( text === '' ) { this.clearControlValue(); }
	}

	private updateCurrentTextLength( text: string ) {
		this.currentTextLength = text?.length ?? 0;
	}

	updateRevertValue( text: string ) {
		if ( text ) { this.revertValue = text; }
		this.updateCurrentTextLength( text );
	}

	ngOnInit() {
		super.ngOnInit();
		this.updateCurrentTextLength( this.control?.value );

		this.control?.valueChanges
		.subscribe( text => {
			this.updateActionButtonsVisibility( !!text?.trim().length );
			this.updateRevertValue( text );
			this.clearOnEmptyString( text )
		} );
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}
}
